import { SeverityLevel } from '@uipath/telemetry-client-web';

import { IAppInsightsModel } from '../../models/appInsights/appInsightsModel';
import Logger from '../logger/logger';
import {
    getAccountName,
    getTenantName,
} from '../urlHelper';

export function addGlobalUnHandledExceptionCatcher(instance: IAppInsightsModel) {
    Logger.debug('appInsights', 'initializing globalUnhandledExceptionCatcher');

    window.addEventListener('error', (event: ErrorEvent) => {
        // Get the error properties from the error event object
        const {
            message, filename, lineno, colno, error,
        } = event;

        // If the error is not from an apollo package, we let it bubble
        if (!filename?.includes('/apollo-packages/')) {
            return;
        }

        instance.trackerMethods?.trackError(
            new Error('[globalUnhandledExceptionCatcher] - ' + message),
            SeverityLevel.Critical,
            {
                component: 'globalUnhandledExceptionCatcher',
                object: {
                    error,
                    filename,
                    lineno,
                    colno,
                },
                stack: error?.stack,
                accountName: getAccountName(),
                tenantName: getTenantName(),
            },
        );

        event.stopPropagation();
    });
}

